var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "22px",
    viewBox: "0 0 17 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_Test") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "13.2103863%",
    x2: "78.7447867%",
    y2: "86.2935911%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7405",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10_Chapter_page",
    transform: "translate(-507.000000, -976.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35-Copy",
    transform: "translate(490.000000, 921.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(0.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_Test",
    transform: "translate(14.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Test_icon",
    transform: "translate(3.600000, 0.400000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#005DCC",
    x: 0.648855597,
    y: 6.4732834,
    width: 15.1,
    height: 14.6,
    rx: 1.78110695
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 0.0488555972,
    y: 6.1732834,
    width: 15.1,
    height: 14.6,
    rx: 1.78110695
  }), /*#__PURE__*/React.createElement("g", {
    id: "DBlue",
    transform: "translate(2.400000, 15.200000)",
    stroke: "#005DCC",
    strokeLinecap: "round",
    strokeWidth: 1.06866421
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(6.700000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.54756214e-12,-1.27897698e-14 L3.20599264,3.20599264",
    id: "Path-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.54756214e-12,-1.27897698e-14 L3.20599264,3.20599264",
    id: "Path-20",
    transform: "translate(1.602996, 1.602996) scale(-1, 1) translate(-1.602996, -1.602996) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.04000008 L1.20000005,3.24000013",
    id: "Path-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.32000005,-1.06581415e-14 L4.52599269,3.20599264",
    id: "Path-20",
    transform: "translate(2.922996, 1.602996) scale(-1, 1) translate(-2.922996, -1.602996) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "White",
    transform: "translate(2.800000, 15.600000)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeWidth: 1.06866421
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(6.700000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.54756214e-12,-1.27897698e-14 L3.20599264,3.20599264",
    id: "Path-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.54756214e-12,-1.27897698e-14 L3.20599264,3.20599264",
    id: "Path-20",
    transform: "translate(1.602996, 1.602996) scale(-1, 1) translate(-1.602996, -1.602996) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.04000008 L1.20000005,3.24000013",
    id: "Path-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.32000005,-1.06581415e-14 L4.52599269,3.20599264",
    id: "Path-20",
    transform: "translate(2.922996, 1.602996) scale(-1, 1) translate(-2.922996, -1.602996) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.800000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF6813",
    cx: 7.01348324,
    cy: 7.01348324,
    r: 6.49213492
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-2)",
    cx: 6.49213492,
    cy: 6.49213492,
    r: 6.49213492
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.182697, 1.642697)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 5.30943833,
    cy: 0.721348324,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 5.30943833,
    cy: 9.72134832,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    transform: "translate(9.809438, 5.221348) rotate(-270.000000) translate(-9.809438, -5.221348) ",
    cx: 9.80943833,
    cy: 5.22134832,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    transform: "translate(0.809438, 5.221348) rotate(-270.000000) translate(-0.809438, -5.221348) ",
    cx: 0.809438331,
    cy: 5.22134832,
    r: 1
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-21",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "3.3 4.74529287 5.14397686 6.2 8.3 3.3"
  })))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/test-icon.20a75951687a8aaa676c3a3804a52e53.svg";
export { ForwardRef as ReactComponent };